import { useEffect, useRef } from 'react';
import { useLocation } from '@tanstack/react-router';
import { AnalyticsService } from '../services/analytics.service';

export const useAnalytics = () => {
  const location = useLocation();
  const lastPath = useRef<string | null>(null);

  useEffect(() => {
    if (lastPath.current !== location.pathname) {
      lastPath.current = location.pathname;
      // Track page view when location changes
      const pageName = location.pathname === '/' ? 'Home' : location.pathname.slice(1).replace(/-/g, ' ');
      AnalyticsService.trackPageView(pageName, location.pathname);
    }
  }, [location.pathname]);
}; 